export const COLLECTIONS_ERROR = 'COLLECTIONS_ERROR' as const;
export const COLLECTIONS_LOADING = 'COLLECTIONS_LOADING' as const;
export const COLLECTIONS_GET_SINGLE = 'COLLECTIONS_GET_SINGLE' as const;
export const CLEAR_COLLECTIONS_SINGLE = 'CLEAR_COLLECTIONS_SINGLE' as const;
export const COLLECTION_OPENED = 'COLLECTION_OPENED';
export const COLLECTION_SEND_RATING = 'LEARNING_NUGGET_SEND_RATING' as const;
